// src/utils/helpers.ts
export function getErrorMessage(error: unknown): string {
    if (!error) return "Unknown error occurred";
    if (typeof error === "string") return error;
    if ((error as any).message) return (error as any).message;
    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
}
